import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = {
  vat: 18,
  income_tax: 25,
  social_security: 5,
};

export function SettingsProvider({ children }) {
  const [taxRates, setTaxRates] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const res = await api.get("/settings/tax");
      const parsed = {
        vat: Number(res.data.vat),
        income_tax: Number(res.data.income_tax),
        social_security: Number(res.data.social_security),
      };
      setTaxRates({
        vat: Number.isFinite(parsed.vat) ? parsed.vat : DEFAULTS.vat,
        income_tax: Number.isFinite(parsed.income_tax) ? parsed.income_tax : DEFAULTS.income_tax,
        social_security: Number.isFinite(parsed.social_security) ? parsed.social_security : DEFAULTS.social_security,
      });
    } catch {
      setTaxRates(DEFAULTS);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const save = async (next) => {
    const payload = {
      vat: Number(next.vat),
      income_tax: Number(next.income_tax),
      social_security: Number(next.social_security),
    };
    setTaxRates(payload); // optimistic
    await api.put("/settings/tax", payload);
  };

  const rates = {
    vat: taxRates.vat / 100,
    income_tax: taxRates.income_tax / 100,
    social_security: taxRates.social_security / 100,
    total: (taxRates.vat + taxRates.income_tax + taxRates.social_security) / 100,
  };

  return (
    <SettingsContext.Provider value={{ taxRates, rates, save, loading, reload: load }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
